import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ValidationErrorInterface } from '../model/interface/crud-response-interface.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  constructor() {}
  public getTranslatedErrorMessage(data: any[]): void {
    try {
      data.forEach((message) => {
        if (!message.success) {
          const messages: string[] = [];
          message.message.forEach((errorMessage) => {
            if (errorMessage.constraints.hasOwnProperty('isNotEmpty')) {
              this.appendApiError(errorMessage, ['isNotEmpty'], messages);
            } else {
              this.appendApiError(errorMessage, Object.keys(errorMessage.constraints), messages);
            }
          });
          _.set(message, 'message', messages);
        }
      });
    } catch (error) {
      if (error instanceof TypeError) {
        return;
      }
      throw error;
    }
  }

  public getOption(errorKey: string, errorMessage: ValidationErrorInterface): string {
    if (errorKey === 'whitelistValidation') {
      const whitelistReason = Object.keys(_.get(errorMessage, `contexts.${errorKey}`, {}))[0] || null;
      const whitelistReasonKey = `apiErrorMessages.${whitelistReason}`;

      return whitelistReason ? `${(whitelistReasonKey)} ` : '';
    }

    const compareProperty = _.get(errorMessage, `contexts.${errorKey}.compareProperty`, false);

    if (compareProperty) {
      return (`apiErrorMessages.properties.${compareProperty}`);
    }

    const translateOption = _.get(errorMessage, `contexts.${errorKey}.translateOption`, false);

    if (translateOption) {
      return (`apiErrorMessages.translateOption.${translateOption}`);
    }

    return _.get(errorMessage, `contexts.${errorKey}.option]`, '');
  }

  public appendApiError(errorMessage: ValidationErrorInterface, errorKeys: string[], messages: string[]): void {
    errorKeys.forEach((errorKey) => {
     
    });
  }

  public additionalOptions(errorKey: string, errorMessage: ValidationErrorInterface): {[key: string]: string} {
    const additionalOptions = {};
    for (const [key, value] of Object.entries(_.get(errorMessage, `contexts.${errorKey}`, {}))) {
      const translateString = `apiErrorMessages.additionalOptions.${errorKey}.${key}`;
      const translatedResult = (translateString);

      _.set(additionalOptions, key, translateString === translatedResult ? value : translatedResult);
    }

    return additionalOptions;
  }
}
